/* eslint-disable */

<template>
  <div>
    <div class="vx-row">

      <div class="vx-col lg:w-4/12 md:w-5/12 sm:w-5/5 mb-4">
        <vx-card style="height: 42rem; overflow-y: auto">

          <!-- Task 1 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task1Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task1Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task1Done?'#28C76F':'#4a5568'}">1</span>
              <span class="font-semibold text-sm flex-1">OSPF process 33 + router-id</span>
              <span class="text-xs font-medium" :class="task1Done?'text-success':'text-grey'">{{ task1Progress }}/2</span>
            </div>
            <div class="px-3 py-2">
              <p class="text-xs mb-2 ml-1" style="color:#9ca3af">Tip: run <code>show ip interface brief</code> to find E0/1 IP</p>
              <div class="space-y-1 ml-1">
                <div v-for="item in task1Items" :key="'t1-'+item.key" class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(r1Completion[item.key])"></div>
                  <code class="text-base" :class="r1Completion[item.key]?'text-success':''">{{ item.label }}</code>
                </div>
              </div>
            </div>
          </div>

          <!-- Task 2 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task2Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task2Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task2Done?'#28C76F':'#4a5568'}">2</span>
              <span class="font-semibold text-sm flex-1">Enable OSPF area 0 + priority 255 on both interfaces</span>
              <span class="text-xs font-medium" :class="task2Done?'text-success':'text-grey'">{{ task2Progress }}/6</span>
            </div>
            <div class="px-3 py-2">
              <p class="text-xs mb-1 ml-1" style="color:#9ca3af">e0/0</p>
              <div class="space-y-1 ml-1 mb-2">
                <div v-for="item in task2E00Items" :key="'t2-e00-'+item.key" class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(r1Completion[item.key])"></div>
                  <code class="text-base" :class="r1Completion[item.key]?'text-success':''">{{ item.label }}</code>
                </div>
              </div>
              <p class="text-xs mb-1 ml-1" style="color:#9ca3af">e0/1</p>
              <div class="space-y-1 ml-1">
                <div v-for="item in task2E01Items" :key="'t2-e01-'+item.key" class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(r1Completion[item.key])"></div>
                  <code class="text-base" :class="r1Completion[item.key]?'text-success':''">{{ item.label }}</code>
                </div>
              </div>
            </div>
          </div>

          <!-- Verify -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(r1Completion.clearOspf?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:r1Completion.clearOspf?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <feather-icon :icon="r1Completion.clearOspf?'CheckCircleIcon':'CircleIcon'" :svgClasses="r1Completion.clearOspf?'text-success':'text-grey'" size="16" class="flex-shrink-0" />
              <span class="font-semibold text-sm flex-1">Clear OSPF &amp; verify</span>
              <span class="text-xs font-medium" :class="r1Completion.clearOspf?'text-success':'text-grey'">{{ r1Completion.clearOspf?1:0 }}/1</span>
            </div>
            <div class="px-3 py-2">
              <div class="space-y-1 ml-1 mb-2">
                <div class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(r1Completion.clearOspf)"></div>
                  <code class="text-base" :class="r1Completion.clearOspf?'text-success':''">clear ip ospf process</code>
                </div>
              </div>
              <p class="text-xs ml-1" style="color:#6b7280">Then run: <code>show ip ospf neighbor</code> or <code>show ip ospf interface</code></p>
            </div>
          </div>

          <!-- Save -->
          <div class="rounded-lg mb-2 overflow-hidden" :style="{border:'1px solid '+(r1Completion.saved?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:r1Completion.saved?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <feather-icon :icon="r1Completion.saved?'CheckCircleIcon':'CircleIcon'" :svgClasses="r1Completion.saved?'text-success':'text-grey'" size="16" class="flex-shrink-0" />
              <span class="font-semibold text-sm flex-1">Save Configuration</span>
            </div>
            <div class="px-3 py-2">
              <div class="space-y-1 ml-1">
                <div class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(r1Completion.saved)"></div>
                  <code class="text-base" :class="r1Completion.saved?'text-success':''">copy running-config startup-config</code>
                </div>
              </div>
            </div>
          </div>

        </vx-card>
      </div>

      <div class="vx-col lg:w-8/12 md:w-7/12 sm:w-5/5">
        <div style="height: 35rem">
          <vue-command key="r1" id="r1_terminal" :commands="r1Commands" :prompt="r1Prompt" :show-intro="true" intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="R1" />
        </div>

        <!-- Topology -->
        <div class="topology-card">
          <img :src="topologyImage" alt="Network topology" class="topology-img" />
        </div>
      </div>

    </div>
  </div>
</template>

<script>
/* eslint-disable */
import VueCommand, { createStdout, createStderr } from 'vue-command';
import 'vue-command/dist/vue-command.css';

const HELP = 'Type commands as shown in the task checklist. Use "show ip interface brief", "show ip ospf neighbor", or "show ip ospf interface" to verify.';

const mkCommands = (vm) => ({
  help:        () => createStdout(HELP),
  enable:      () => vm.iosEnable(),
  configure:   (x) => vm.iosConfigure(x),
  conf:        (x) => vm.iosConfigure(x),
  router:      (x) => vm.iosRouter(x),
  'router-id': (x) => vm.iosRouterId(x),
  interface:   (x) => vm.iosInterface(x),
  int:         (x) => vm.iosInterface(x),
  ip:          (x) => vm.iosIp(x),
  clear:       (x) => vm.iosClear(x),
  do:          (x) => vm.iosDo(x),
  show:        (x) => vm.iosShow(x),
  exit:        () => vm.iosExit(),
  end:         () => vm.iosEnd(),
  copy:        (x) => vm.iosCopy(x),
});

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      topologyImage: 'https://ip-learn.b-cdn.net/simulations/ccna-topologies/OSPF_Configuration_Sim3.png',
      totalScore: 0,

      r1: { mode: 'exec', currentIf: null },

      // 10 total keys
      r1Completion: {
        routerOspf: false, routerId: false,
        e00If: false, e00Ospf: false, e00OspfPri: false,
        e01If: false, e01Ospf: false, e01OspfPri: false,
        clearOspf: false,
        saved: false,
      },

      r1Commands: null,

      task1Items: [
        { key: 'routerOspf', label: 'router ospf 33' },
        { key: 'routerId',   label: 'router-id 10.0.33.1' },
      ],
      task2E00Items: [
        { key: 'e00If',      label: 'interface e0/0' },
        { key: 'e00Ospf',    label: 'ip ospf 33 area 0' },
        { key: 'e00OspfPri', label: 'ip ospf priority 255' },
      ],
      task2E01Items: [
        { key: 'e01If',      label: 'interface e0/1' },
        { key: 'e01Ospf',    label: 'ip ospf 33 area 0' },
        { key: 'e01OspfPri', label: 'ip ospf priority 255' },
      ],
    };
  },

  computed: {
    r1Prompt() {
      const m = this.r1.mode;
      if (m === 'config-router') return 'R1(config-router)#';
      if (m === 'config-if')     return 'R1(config-if)#';
      if (m === 'config')        return 'R1(config)#';
      return 'R1#';
    },
    task1Progress() { return [this.r1Completion.routerOspf, this.r1Completion.routerId].filter(Boolean).length; },
    task1Done()     { return this.task1Progress === 2; },
    task2Progress() {
      const c = this.r1Completion;
      return [c.e00If, c.e00Ospf, c.e00OspfPri, c.e01If, c.e01Ospf, c.e01OspfPri].filter(Boolean).length;
    },
    task2Done() { return this.task2Progress === 6; },
  },

  mounted() {
    this.dataLocal.options.showMarkButton = false;
    this.$emit('simulation_update_options', this.dataLocal);
    this.r1Commands = mkCommands(this);
  },

  methods: {
    dot(val) {
      return { width:'8px', height:'8px', background: val?'#28C76F':'transparent', border:'2px solid '+(val?'#28C76F':'#6b7280') };
    },

    guide(msg) {
      return `<span style="color:#28C76F;display:block;margin-top:6px;padding:4px 8px;border-left:2px solid #28C76F;font-size:0.85em;line-height:1.5">${msg}</span>`;
    },

    normalizeIf(ifStr) {
      return (ifStr || '').toLowerCase()
        .replace(/^gigabitethernet/, '')
        .replace(/^fastethernet/, '')
        .replace(/^ethernet/, '')
        .replace(/^gi(?=\d)/, '')
        .replace(/^fa(?=\d)/, '')
        .replace(/^e(?=\d)/, '')
        .replace(/^g(?=\d)/, '')
        .trim();
    },

    updateScore() {
      const score = Object.values(this.r1Completion).filter(Boolean).length;
      this.totalScore = score;
      this.$forceUpdate();
      this.$emit('simulation_update_score', score);
      if (score >= 10) setTimeout(() => this.$emit('simulation_full_correct', score), 500);
    },

    iosEnable() { this.r1.mode = 'exec'; return createStdout(''); },

    iosConfigure(x) {
      if (this.r1.mode !== 'exec') return createStderr('% Already in configuration mode — type "end" to return to exec first');
      if (x._[1] === 'terminal' || x._[1] === 't') {
        this.r1.mode = 'config';
        return createStdout('Enter configuration commands, one per line.  End with CNTL/Z.');
      }
      return createStderr('% Invalid input detected');
    },

    iosExit() {
      const s = this.r1;
      if (s.mode === 'config-if' || s.mode === 'config-router') { s.mode = 'config'; s.currentIf = null; }
      else if (s.mode === 'config') { s.mode = 'exec'; }
      return createStdout('');
    },

    iosEnd() { this.r1.mode = 'exec'; this.r1.currentIf = null; return createStdout(''); },

    iosRouter(x) {
      const s = this.r1;
      if (s.mode !== 'config') return createStderr('% Invalid input detected — must be in global configuration mode');
      if ((x._[1] || '').toLowerCase() === 'ospf' && String(x._[2] || '') === '33') {
        s.mode = 'config-router';
        const c = this.r1Completion;
        if (!c.routerOspf) { c.routerOspf = true; this.updateScore(); }
        return createStdout(this.guide(
          'OSPF process 33 created on R1. The process ID is locally significant — it only needs to be unique on this router, not match the process IDs on R2 or R3. ' +
          '→ Set the router ID: "router-id 10.0.33.1" (the IP of E0/1, found with "show ip interface brief").'
        ));
      }
      return createStderr('% Invalid input detected');
    },

    iosRouterId(x) {
      const s = this.r1;
      if (s.mode !== 'config-router') return createStderr('% Invalid input detected — must be in OSPF router configuration mode ("router ospf 33" first)');
      const rid = String(x._[1] || '');
      const c   = this.r1Completion;
      if (rid === '10.0.33.1' && !c.routerId) {
        c.routerId = true; this.updateScore();
        return createStdout(this.guide(
          'Router ID set to 10.0.33.1. This uniquely identifies R1 in the OSPF domain and is used in LSAs and as a tiebreaker in DR/BDR elections. ' +
          'Using a stable interface IP (E0/1) ensures the router ID doesn\'t change if other interfaces go down. ' +
          '→ "exit" back to config mode, then "interface e0/0" to enable OSPF on the interfaces.'
        ));
      }
      return createStdout('');
    },

    iosInterface(x) {
      const s = this.r1;
      if (s.mode !== 'config' && s.mode !== 'config-if') {
        return createStderr('% Invalid input detected — must be in global or interface configuration mode');
      }
      let ifArg = String(x._[1] || '');
      if (ifArg.toLowerCase() === 'vlan' && x._[2]) ifArg = 'vlan' + x._[2];
      const ifNorm = this.normalizeIf(ifArg) || ifArg.toLowerCase();
      s.mode = 'config-if'; s.currentIf = ifNorm;
      const c = this.r1Completion;
      if (ifNorm === '0/0' && !c.e00If) { c.e00If = true; this.updateScore(); }
      if (ifNorm === '0/1' && !c.e01If) { c.e01If = true; this.updateScore(); }
      return createStdout('');
    },

    iosIp(x) {
      const s = this.r1;
      if (s.mode !== 'config-if') return createStderr('% Invalid input detected — must be in interface configuration mode');
      if ((x._[1] || '').toLowerCase() !== 'ospf') return createStderr('% Invalid input detected');

      const sub2 = (x._[2] || '').toLowerCase();
      const c    = this.r1Completion;
      const ifn  = s.currentIf;

      // ip ospf priority <value>
      if (sub2 === 'priority') {
        const pri = String(x._[3] || '');
        if (pri === '255') {
          if (ifn === '0/0' && !c.e00OspfPri) {
            c.e00OspfPri = true; this.updateScore();
            return createStdout(this.guide(
              'R1 e0/0 OSPF priority set to 255. R1 will always win the DR election on the 10.0.22.0 segment — R2 will become BDR. ' +
              '→ "interface e0/1" to configure the E0/1 interface.'
            ));
          }
          if (ifn === '0/1' && !c.e01OspfPri) {
            c.e01OspfPri = true; this.updateScore();
            return createStdout(this.guide(
              'R1 e0/1 OSPF priority set to 255. R1 is now DR on both segments. ' +
              '→ "end" to reach exec mode, then "clear ip ospf process" to trigger a new DR election.'
            ));
          }
        }
        return createStdout('');
      }

      // ip ospf <process-id> area <area-id>
      const processId = sub2;
      const areaKw    = (x._[3] || '').toLowerCase();
      const areaId    = String(x._[4] || '');
      if (processId !== '33' || areaKw !== 'area' || areaId !== '0') return createStdout('');

      if (ifn === '0/0' && !c.e00Ospf) {
        c.e00Ospf = true; this.updateScore();
        return createStdout(this.guide(
          'OSPF process 33, area 0 enabled on R1 e0/0 via the interface command. R1 will form an adjacency with R2 on the 10.0.22.0 segment without needing a "network" statement. ' +
          '→ "ip ospf priority 255" to ensure R1 is always DR on this segment.'
        ));
      }
      if (ifn === '0/1' && !c.e01Ospf) {
        c.e01Ospf = true; this.updateScore();
        return createStdout(this.guide(
          'OSPF process 33, area 0 enabled on R1 e0/1. R1 will form an adjacency with R3 on the 10.0.33.0 segment. ' +
          '→ "ip ospf priority 255" to ensure R1 is always DR on this segment.'
        ));
      }

      return createStdout('');
    },

    iosClear(x) {
      if (this.r1.mode !== 'exec') return createStderr('% Must be in privileged EXEC mode — type "end" first');
      if ((x._[1]||'').toLowerCase()==='ip' && (x._[2]||'').toLowerCase()==='ospf' && (x._[3]||'').toLowerCase()==='process') {
        const c = this.r1Completion;
        if (!c.clearOspf) { c.clearOspf = true; this.updateScore(); }
        return createStdout(
          'Reset ALL OSPF processes? [no]: y<br>% OSPF: Clearing process ...' +
          this.guide(
            'OSPF process reset on R1. All existing adjacencies are dropped and DR elections re-run. ' +
            'With priority 255 on both E0/0 and E0/1, R1 wins both elections unconditionally. ' +
            '→ Verify with "show ip ospf neighbor" (R2 and R3 should appear as FULL/BDR) or "show ip ospf interface" (State: DR, Priority: 255 on both interfaces).'
          )
        );
      }
      return createStderr('% Invalid input detected');
    },

    iosDo(x) {
      const sub1 = (x._[1] || '').toLowerCase();
      if (sub1 === 'clear') {
        const fakeX = { _: ['clear'].concat(x._.slice(2)) };
        const orig = this.r1.mode;
        this.r1.mode = 'exec';
        const result = this.iosClear(fakeX);
        this.r1.mode = orig;
        return result;
      }
      if (sub1 === 'show') {
        const fakeX = { _: ['show'].concat(x._.slice(2)) };
        return this.iosShow(fakeX);
      }
      return createStderr('% Invalid input detected');
    },

    iosShow(x) {
      const sub1 = (x._[1] || '').toLowerCase();
      const sub2 = (x._[2] || '').toLowerCase();
      const sub3 = (x._[3] || '').toLowerCase();
      const c    = this.r1Completion;

      // show ip interface brief
      if (sub1 === 'ip' && sub2 === 'interface' && sub3 === 'brief') {
        return createStdout(
          'Interface&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;IP-Address&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;OK?&nbsp;Method&nbsp;Status&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Protocol<br>' +
          'Ethernet0/0&nbsp;&nbsp;&nbsp;&nbsp;10.0.22.1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;YES&nbsp;Manual&nbsp;up&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;up<br>' +
          'Ethernet0/1&nbsp;&nbsp;&nbsp;&nbsp;10.0.33.1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;YES&nbsp;Manual&nbsp;up&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;up' +
          this.guide('E0/1 IP address is 10.0.33.1 — use this as the OSPF router ID. → "router ospf 33" then "router-id 10.0.33.1".')
        );
      }

      // show ip ospf neighbor
      if (sub1 === 'ip' && sub2 === 'ospf' && sub3 === 'neighbor') {
        const ready = c.e00Ospf && c.e01Ospf && c.clearOspf;
        const hdr   = 'Neighbor ID&nbsp;&nbsp;Pri&nbsp;&nbsp;State&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Dead Time&nbsp;&nbsp;Address&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Interface<br>';
        if (!ready) return createStdout(hdr + this.guide('No neighbors yet — complete Task 2 and clear OSPF process first.'));
        return createStdout(hdr +
          '10.2.2.2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1&nbsp;&nbsp;&nbsp;&nbsp;FULL/BDR&nbsp;&nbsp;00:00:35&nbsp;&nbsp;&nbsp;10.0.22.2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;GigabitEthernet0/0<br>' +
          '10.3.3.3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1&nbsp;&nbsp;&nbsp;&nbsp;FULL/BDR&nbsp;&nbsp;00:00:35&nbsp;&nbsp;&nbsp;10.0.33.3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;GigabitEthernet0/1' +
          this.guide('R2 (10.2.2.2) and R3 (10.3.3.3) are both FULL/BDR — confirming R1 is DR on both segments.')
        );
      }

      // show ip ospf interface
      if (sub1 === 'ip' && sub2 === 'ospf' && sub3 === 'interface') {
        const ready = c.e00Ospf && c.e00OspfPri && c.e01Ospf && c.e01OspfPri;
        if (!ready) return createStdout(this.guide('Complete Task 2 (OSPF + priority 255 on both interfaces) first.'));
        return createStdout(
          'Ethernet0/0 is up, line protocol is up<br>' +
          '&nbsp;&nbsp;Internet address is 10.0.22.1/30, Area 0<br>' +
          '&nbsp;&nbsp;Process ID 33, Router ID ' + (c.routerId ? '10.0.33.1' : '(not set)') + ', Network Type BROADCAST, Cost: 1<br>' +
          '&nbsp;&nbsp;Transmit Delay is 1 sec, State DR, Priority 255<br>' +
          'Ethernet0/1 is up, line protocol is up<br>' +
          '&nbsp;&nbsp;Internet address is 10.0.33.1/29, Area 0<br>' +
          '&nbsp;&nbsp;Process ID 33, Router ID ' + (c.routerId ? '10.0.33.1' : '(not set)') + ', Network Type BROADCAST, Cost: 1<br>' +
          '&nbsp;&nbsp;Transmit Delay is 1 sec, State DR, Priority 255' +
          this.guide('Both interfaces show State: DR, Priority: 255 — R1 is always the DR on both segments.')
        );
      }

      return createStderr('% Invalid input detected');
    },

    iosCopy(x) {
      if (this.r1.mode !== 'exec') return createStderr('% Must be in privileged EXEC mode — type "end" first');
      const c = this.r1Completion;
      if (x._[1] === 'running-config' && x._[2] === 'startup-config') {
        if (!c.saved) { c.saved = true; this.updateScore(); }
        return createStdout('Destination filename [startup-config]?<br>Building configuration...<br>[OK]' +
          this.guide('R1 configuration saved to NVRAM. ✓ Simulation complete!'));
      }
      return createStderr('% Invalid input detected');
    },
  },

  components: { VueCommand },
  props: { data: { type: Object, required: true } },
};
</script>

<style>
#r1_terminal { overflow: hidden !important; }

.topology-card {
  margin-top: 1.5rem;
  background-color: #111111;
  border: 1px solid #181d2a;
  border-radius: 0.5rem;
  overflow: hidden;
  line-height: 0;
}
.topology-img {
  display: block;
  width: 100%;
  height: auto;
  max-width: 100%;
}
</style>

